<div class="modal-content">
    <div class="modal-header border-0">
        <h2 class="modal-title" id="modulesModalLabel">{{(isEdit) ? 'Editar': 'Nuevos'}} datos de facturación</h2>
        <button type="button" class="btn-close" (click)="modalService.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <div class="row">
            <div class="col-sm-12">
                <div class="card height-equal title-line">
                    <form [formGroup]="billingForm" class="mt-4">
                        <div class="row">
                            <!-- Razón social -->
                            <div class="col-md-6 mb-3">
                                <label class="form-check-label ms-2">
                                    Razón social *
                                </label>
                                <input type="text" class="form-control"
                                       [class.is-invalid]="billingForm.get('businessNames')?.touched && billingForm.get('businessNames')?.invalid"
                                       formControlName="businessNames" placeholder="">

                                <div *ngIf="billingForm.get('businessNames')?.touched && billingForm.get('businessNames')?.invalid" class="invalid-feedback">
                                    Ingrese un valor válido.
                                </div>
                            </div>
                            <!-- RFC -->
                            <div class="col-md-6 mb-3">
                                <label class="form-check-label ms-2">
                                    RFC *
                                </label>
                                <input type="text" class="form-control"
                                       [class.is-invalid]="billingForm.get('rfc')?.touched && billingForm.get('rfc')?.invalid"
                                       formControlName="rfc" placeholder="">

                                <div *ngIf="billingForm.get('rfc')?.touched && billingForm.get('rfc')?.invalid" class="invalid-feedback">
                                    Ingrese un valor válido.
                                </div>
                            </div>
                            <!-- Dirección fiscal -->
                            <div class="col-md-6 mb-3">
                                <label class="form-check-label ms-2">
                                    Dirección fiscal *
                                </label>
                                <textarea
                                        class="form-control"
                                        rows="1"
                                        required="true"
                                        formControlName="fiscalAddress"
                                        maxlength="255"
                                        [class.is-invalid]="billingForm.get('fiscalAddress')?.touched && billingForm.get('fiscalAddress')?.invalid"
                                ></textarea>

                                <div *ngIf="billingForm.get('fiscalAddress')?.touched && billingForm.get('fiscalAddress')?.invalid" class="invalid-feedback">
                                    Ingrese un valor válido.
                                </div>
                            </div>
                            <!-- CP -->
                            <div class="col-md-6 mb-3">
                                <label class="form-check-label ms-2">
                                    CP *
                                </label>
                                <input type="text" class="form-control" maxlength="5"
                                       [class.is-invalid]="billingForm.get('postalCode')?.touched && billingForm.get('postalCode')?.invalid"
                                       formControlName="postalCode" placeholder="">

                                <div *ngIf="billingForm.get('postalCode')?.touched && billingForm.get('postalCode')?.invalid" class="invalid-feedback">
                                    Ingrese un valor válido.
                                </div>
                            </div>
                            <!-- Uso CFDI -->
                            <div class="col-md-6 mb-3">
                                <label class="form-check-label ms-2">
                                    Uso CFDI *
                                </label>
                                <select class="form-select" formControlName="cfdiUse" [class.is-invalid]="billingForm.get('cfdiUse')?.touched && billingForm.get('cfdiUse')?.invalid">
                                    <option [ngValue]="null" disabled selected>Seleccione el Uso CFDI</option>
                                    <option *ngFor="let cfdi of cfdiUses" [value]="cfdi.id">{{ cfdi.value }}</option>
                                </select>

                                <div *ngIf="billingForm.get('cfdiUse')?.touched && billingForm.get('cfdiUse')?.invalid" class="invalid-feedback">
                                    Seleccione un valor válido.
                                </div>
                            </div>
                            <!-- Email -->
                            <div class="col-md-6 mb-3">
                                <label class="form-check-label ms-2">
                                    Correo electrónico adicional
                                </label>
                                <input type="text" class="form-control"
                                       formControlName="additionalEmail" placeholder="">

                                <div *ngIf="billingForm.get('additionalEmail')?.touched && billingForm.get('additionalEmail')?.invalid" class="invalid-feedback">
                                    Ingrese un correo válido.
                                </div>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-check-label ms-2">
                                    Constancia de situación fiscal *
                                </label>

                                <!-- Mostrar solo si no está en modo de edición (isEdit == false) -->
                                <div *ngIf="!isEdit || (isEdit && isEditPDF)">
                                    <input type="file" class="form-control"
                                           [class.is-invalid]="billingForm.get('taxCertificate')?.touched && billingForm.get('taxCertificate')?.invalid"
                                           (change)="onFileChange($event)">
                                    <div *ngIf="billingForm.get('taxCertificate')?.touched && billingForm.get('taxCertificate')?.invalid" class="invalid-feedback">
                                        Seleccione un archivo.
                                    </div>
                                </div>

                                <!-- Mostrar solo si está en modo de edición (isEdit == true) -->
                                <div *ngIf="isEdit && !isEditPDF" class="file-content">
                                    <ul class="files">
                                        <li class="file-box">
                                            <div class="file-top" (click)="downloadPDF()"> <i class="fa fa-file-image-o txt-primary2"></i>
                                                <i class="fa fa-ellipsis-v f-14 ellips"></i>
                                            </div>
                                            <div class="file-bottom">
                                                <h6 class="mt-3">Constancia.pdf</h6>
                                                <div class="row mt-2">
                                                    <a href="javascript:void(0)" (click)="downloadPDF()">Descargar</a>
                                                </div>
                                                <div class="row mt-1">
                                                    <a href="javascript:void(0)" (click)="isEditPDF = !isEditPDF"> Nuevo <b>PDF</b></a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>


                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <!-- Botones form-->
        <div class="d-flex justify-content-end gap-2 mt-2">
            <button type="button" class="btn btn-primary col-auto" (click)="submitForm()">Aceptar</button>
        </div>
    </div>
</div>
